// extracted by mini-css-extract-plugin
export default {"backdrop":"GlobalLoader_backdrop__lDCLF","loader":"GlobalLoader_loader__qtjWO","spin":"GlobalLoader_spin__AlnYD"};